import { Button } from "antd";
import classNames from "classnames";
import { PropsWithChildren } from "react";

interface WithSaveButtonProps {
    onSave?: () => void;
    className?: string;
    hideSaveButton?: boolean;
}

export const WithSaveButton = ({
    children,
    onSave,
    className,
    hideSaveButton = false,
}: PropsWithChildren<WithSaveButtonProps>) => {
    return (
        <div className={classNames("flex items-center gap-2 w-full", className)}>
            {children}
            {!hideSaveButton && (
                <Button
                    htmlType={"button"}
                    type={"primary"}
                    size={"middle"}
                    onClick={(e) => {
                        e.stopPropagation();
                        onSave?.();
                    }}
                >
                    {"Save"}
                </Button>
            )}
        </div>
    );
};
